import axios from '../utils/axios.js'

export const personList = (query) => axios.setAxiosGetPromise('ioam/queryPerson', query)

export const departmentList = () => axios.setAxiosGetPromise('/ioam/queryDepart')



// WEBPACK FOOTER //
// ./src/services/ioam.js